import { writable } from 'svelte/store'

// List of publications in LitShop
export const publications = writable([])
export const cart_totals = writable(0)
